import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Button,
  Modal,
} from '@printdeal/ui-library';

interface ExploreDesignTemplateModalProps {
  handleCloseModal: () => void;
}
const ExploreDesignTemplatesModal = ({
  handleCloseModal,
}: ExploreDesignTemplateModalProps) => {
  const intl = useIntl();

  const modalTitle = intl.formatMessage({
    id: 'designTemplate.modal.title',
    defaultMessage: 'Discover our design templates with the design option "Design online"',
  });
  const modalContent = intl.formatMessage({
    id: 'designTemplate.modal.text',
    defaultMessage: `In the future you will see some design templates here. 
    Now, you can find all of our free template in the online editor. Choose the option 'Design Online'`,
  });

  return (
    <Modal
      isOpen
      size="lg"
      onClose={handleCloseModal}
      dismissLabel={intl.formatMessage({
        id: 'generic.modal.close',
        defaultMessage: 'Close',
      })}
      title={modalTitle}
      data-cy="modalExploreDesignTemplate"
    >
      <Modal.Content>
        {modalContent}
      </Modal.Content>
      <Modal.Footer
        className="pd-flex pd-flex-row-reverse pd-flex-wrap pd-gap-2"
      >
        <Button
          variant="secondary"
          onClick={handleCloseModal}
        >
          <FormattedMessage
            id="designTemplate.modal.closeButton"
            defaultMessage="Close"
          />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExploreDesignTemplatesModal;
